const resolveCompanyId = (companies: Array<any>) => {
  const customerCompany = companies?.find((c: any) => c.type === "Customer");
  return customerCompany ? customerCompany.id : companies[0]?.id || null;
};

export { resolveCompanyId };
